// actions/pubsub/inputs.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function inputsHasErrored(bool) {
  return {
    type: 'INPUTS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function inputsIsLoading(bool) {
  return {
    type: 'INPUTS_IS_LOADING',
    isLoading: bool
  };
}

export function inputsFetchDataSuccess(response) {
  return {
    type: 'INPUTS_FETCH_DATA_SUCCESS',
    response
  };
}

export function inputsFetchData(host, body) {
  return (dispatch) => {
    dispatch(inputsIsLoading(true));
    dispatch(inputsHasErrored(false));
    fetch(host + 'user/inputs', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
        
      dispatch(inputsIsLoading(false));
      promise.json()
        .then(result => {
          
          PubSub.publish('pubsub.process.inputs', { guid: body.guid, result: result });
          dispatch(inputsFetchDataSuccess(result))
        })
        .catch((e) => {
          console.log(e);
          PubSub.publish('pubsub.process.inputs', { guid: body.guid, result: [] });
          dispatch(inputsHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
        PubSub.publish('pubsub.process.inputs', { guid: body.guid, result: [] });
        dispatch(inputsHasErrored(true))
      });
  };
}